import React, {useContext} from 'react'
const EqxRadioButtonContext = React.createContext<
    | {
          name: string
          value?: string
          onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
          displayIcon?: string
          variant?: string
      }
    | undefined
>(undefined)
const EqxRadioButton = (props: {
    children: React.ReactNode
    name: string
    value?: string
    className?: string
    displayIcon?: string
    variant?: string
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}) => {
    const context = {
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        className: props.className,
        variant: props.variant,
        displayIcon: props.displayIcon,
    }
    return (
        <EqxRadioButtonContext.Provider value={context}>
            <div className={'btn-group ' + props.className} role="group">
                {props.children}
            </div>
        </EqxRadioButtonContext.Provider>
    )
}
const EqxRadioButtonItem = (props: {value: string; label: string; icon?: string}) => {
    const context = useContext(EqxRadioButtonContext)
    if (!context) throw new Error('EqxRadioButtonItem must be used within an EqxRadioButton')
    const id = context.name + '-' + props.value
    return (
        <>
            <input
                type="radio"
                className="btn-check"
                name={context.name}
                id={id}
                onChange={context.onChange}
                autoComplete="off"
                value={props.value}
                checked={props.value == context.value}
            />
            <label className={'btn btn-sm btn-outline-' + context.variant} htmlFor={id}>
                {props.icon && <span className={props.icon}></span>}
                <span className={context.displayIcon}> {props.label}</span>
            </label>
        </>
    )
}
export {EqxRadioButton as default, EqxRadioButtonItem}
